import(/* webpackMode: "eager" */ "/root/repo/src/app/oauth2/redirect/page.tsx");
